import { NgModule } from '@angular/core';
import { AsProductivityArrayPipe } from './as-productivity-array.pipe';


@NgModule({
    imports: [],
    exports: [AsProductivityArrayPipe],
    declarations: [AsProductivityArrayPipe],
    providers: [],
})
export class AsProductivityArrayPipeModule { }
